import { createApp } from 'vue'
import '../style/style.css'
import { createI18n } from 'petite-vue-i18n'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import messages from '../translations/messages'
import App from './App.vue'
import { routes } from './routes.js'
import { useUserStore } from './stores/user.js'

const init = () => {
  const i18n = createI18n({
    locale: 'nl',
    messages
  })

  const router = createRouter({
    history: createWebHistory(),
    routes
  })

  const app = createApp(App).use(i18n).use(router).use(createPinia())

  const signedIn = document.documentElement.getAttribute('data-signed-in') === 'true'
  const customerId = document.documentElement.getAttribute('data-customer-id')
  if (signedIn) {
    const userStore = useUserStore()
    userStore
      .fetchUser()
      .then(() => userStore.setCustomerId(customerId))
      .finally(() => {
        app.mount('#app')
      })
  } else {
    app.mount('#app')
  }
}

init()
